export enum Language {
  EN = 'En',
  CKB = 'Ckb',
  AR = 'Ar',
  KDB = 'Kdb'
}
